import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/react/react/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../packages/react/src/Header/Header.docs.json';
import DeprecationBanner from '../components/DeprecationBanner';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <DeprecationBanner replacementUrl={'/components/header/react/latest'} mdxType="DeprecationBanner" />
    <h2>{`Examples`}</h2>
    <p>{`All items directly under the Header component should be a `}<inlineCode parentName="p">{`Header.Item`}</inlineCode>{` component. Inside these components can be anything (text, forms, images...), and the `}<inlineCode parentName="p">{`Header.Item`}</inlineCode>{` component will make sure these elements vertically align with each other.`}</p>
    <p><inlineCode parentName="p">{`Header.Item`}</inlineCode>{` elements have a built-in margin that will need to be overridden with the `}<inlineCode parentName="p">{`mr={0}`}</inlineCode>{` props for the last element in the container. We relied on the prop here instead of `}<inlineCode parentName="p">{`:last-child`}</inlineCode>{` because the last child isn't always the item visible. On responsive pages, there's a mobile menu that gets presented to the user at smaller breakpoints.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Header>
  <Header.Item>
    <Header.Link href="#" fontSize={2}>
      <Octicon icon={MarkGithubIcon} size={32} sx={{mr: 2}} />
      <span>GitHub</span>
    </Header.Link>
  </Header.Item>
  <Header.Item full>Menu</Header.Item>
  <Header.Item sx={{mr: 0}}>
    <Avatar src="https://github.com/octocat.png" size={20} square alt="@octocat" />
  </Header.Item>
</Header>
`}</code></pre>
    <h3>{`With full-size item`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Header>
  <Header.Item>Item 1</Header.Item>
  <Header.Item full border={1} borderStyle="solid">
    Item 2
  </Header.Item>
  <Header.Item sx={{mr: 0}}>Item 3</Header.Item>
</Header>
`}</code></pre>
    <h3>{`With links`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Header>
  <Header.Item>
    <Header.Link href="#">About</Header.Link>
  </Header.Item>
  <Header.Item>
    <Header.Link href="#">Releases</Header.Link>
  </Header.Item>
  <Header.Item>
    <Header.Link href="#">Team</Header.Link>
  </Header.Item>
</Header>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: false,
      fullTestCoverage: false,
      usedInProduction: false,
      usageExamplesDocumented: true,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      